/**
 * Handle 250 on phone numbers
 */
export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }

  const digits = phoneNumber.replace(/\D/g, '');
  if (!digits) {
    return phoneNumber;
  }

  let localDigits = digits;
  if (localDigits.startsWith('250')) {
    localDigits = localDigits.slice(3);
  }

  if (localDigits.startsWith('7') && localDigits.length === 9) {
    localDigits = `0${localDigits}`;
  }

  if (localDigits.startsWith('07') && localDigits.length === 10) {
    return `${localDigits.slice(0, 4)} ${localDigits.slice(4, 7)} ${localDigits.slice(7)}`;
  }

  return phoneNumber;
}

/**
 * Normalizes phone to 9 local digits (Rwanda). Handles +250..., 250..., 0788...
 */
function getLocalDigits(phoneNumber: string): string {
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  if (digitsOnly.length >= 10 && digitsOnly.startsWith('0')) {
    return digitsOnly.slice(1, 10);
  }
  if (digitsOnly.length >= 9 && digitsOnly.startsWith('250')) {
    return digitsOnly.replace(/^250/, '').substring(0, 9);
  }
  return digitsOnly.substring(0, 9);
}

/**
 * Formats a full phone number for display with masking: 078***308
 * (first 3 and last 3 digits visible, middle masked for privacy)
 */
export function maskPhoneNumber(phoneNumber?: string | null): string {
  if (!phoneNumber) return '';

  const localDigits = getLocalDigits(phoneNumber);
  if (localDigits.length < 6) return '';

  const first3 = localDigits.startsWith('7') ? `0${localDigits.substring(0, 2)}` : localDigits.substring(0, 3);
  const last3 = localDigits.slice(-3);
  return `${first3}***${last3}`;
}
